import React, { useState, useMemo } from 'react';
import { FiSearch } from 'react-icons/fi';

const SearchBar = ({ onSearch }) => {
  const [searchValue, setSearchValue] = useState('');

   const searchResults = useMemo(() => {
    onSearch(searchValue)
  }, [searchValue]);


  return (
<div className="relative mb-5">
  <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />

  <input
    type="text"
    placeholder="Search questions..."
    value={searchValue}
    className="flex h-10 w-full rounded-md border border-input bg-background pl-10 pr-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm"
    onChange={(e) => setSearchValue(e.target.value)}
  />
</div>
  );
};

export default SearchBar;
